import React from 'react';
import { Tooltip } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
const CustomTooltip = withStyles((theme) => ({
  tooltip: {
    fontSize: 12,
    background: (props) => (props.background ? '#f5f5f5' : ''),
    color: (props) => (props.background ? '#000' : ''),
  },
}))(Tooltip);

export default function CommonTooltip(props) {
  return <CustomTooltip {...props} />;
}
